/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardThreatsSummaryAccountResponse {
    getFixupPrototypeFunction() { return SecurityDashboardThreatsSummaryAccountResponse.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardThreatsSummaryAccountResponse>): SecurityDashboardThreatsSummaryAccountResponse {
        let obj = Object.assign(new SecurityDashboardThreatsSummaryAccountResponse(), model);
        SecurityDashboardThreatsSummaryAccountResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardThreatsSummaryAccountResponse>): SecurityDashboardThreatsSummaryAccountResponse {
        if (!model) return null;
        return SecurityDashboardThreatsSummaryAccountResponse.newInstance(<SecurityDashboardThreatsSummaryAccountResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardThreatsSummaryAccountResponse) {
        if (!obj) return;

        models.SecurityDashboardThreatsSummaryAccountResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardThreatsSummaryAccountResponse): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardThreatsSummaryAccountResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.summary_by_accounts) {
            for (let val of this.summary_by_accounts) {
                models.SecurityDashboardThreatsAccountDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Visibility of the Threats by Account
     */
    summary_by_accounts: Array<models.SecurityDashboardThreatsAccountDetails>;

}
